export default "__VITE_ASSET__0xL6AVmH__"